import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  useEffect(() => {
    document.title = 'Page Not Found | Josh Hastings';

    let robots = document.head.querySelector(
      'meta[name="robots"]',
    ) as HTMLMetaElement | null;

    if (!robots) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      document.head.appendChild(robots);
    }

    robots.setAttribute('content', 'noindex, nofollow');

    return () => {
      robots?.remove();
    };
  }, []);

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50 text-foreground-950 overflow-hidden">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-950/5 select-none pointer-events-none z-0">
        404
      </h1>

      <div className="relative z-10 max-w-xl">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
          404 Error
        </span>

        <h2 className="mt-6 font-heading font-bold text-3xl md:text-5xl text-foreground-950">
          This Page Couldn’t Be Found
        </h2>

        <p className="mt-4 text-base md:text-lg text-foreground-600 leading-relaxed">
          The page you’re looking for may have been moved, deleted, or the URL
          may be incorrect.
        </p>

        <p className="mt-3 text-sm text-foreground-500 font-mono break-all">
          {location.pathname}
        </p>

        <div className="mt-8">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-6 py-3 font-label font-semibold text-sm transition-all duration-300 hover:-translate-y-0.5 bg-primary-500 text-background-950 hover:bg-primary-400 shadow-[0_0_32px_rgba(116,216,189,0.22)]">
            Back to Home
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}
